<template>
  <Textarea
    data-slot="input-group-control"
    :class="cn(
      'tw:flex-1 tw:resize-none tw:rounded-none tw:border-0 tw:bg-transparent tw:py-3 tw:shadow-none tw:focus-visible:ring-0 tw:dark:bg-transparent',
      'tw:field-sizing-content',
      props.class,
    )"
  />
</template>

<script setup>
import { Textarea } from '@/shadcn/components/ui/textarea'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
